import { useQuery } from "@tanstack/react-query";
import { NotificationsKeys } from "web_myplann/Api/Notifications/notificatioKeys";
import { getNotificationsGroupedCountV2 } from "web_myplann/Infrastructure/Api/Api";
import { processResponse } from "web_myplann/Infrastructure/Api/ApiUtils";

export const useGetNotificationsGroupedCountQuery = (
	filterOnlyunread?: boolean,
) => {
	return useQuery({
		queryKey: NotificationsKeys.count(),
		queryFn: processResponse(() =>
			getNotificationsGroupedCountV2(filterOnlyunread),
		),
	});
};
